import { FILE_CACHE_LIFETIME } from "src/constants/limits";

interface CacheEntry {
  file: File;
  timer: ReturnType<typeof setTimeout>;
}

const cache = new Map<string, CacheEntry>();

const keyFor = (file: File): string =>
  `${file.name}|${file.size}|${file.lastModified}`;

const scheduleEviction = (key: string): ReturnType<typeof setTimeout> =>
  setTimeout(() => {
    cache.delete(key);
  }, FILE_CACHE_LIFETIME);

export const cacheGet = (file: File): File | undefined => {
  const key = keyFor(file);
  const entry = cache.get(key);
  if (!entry) {
    return undefined;
  }
  clearTimeout(entry.timer);
  entry.timer = scheduleEviction(key);
  return entry.file;
};

export const cachePut = (source: File, result: File): void => {
  const key = keyFor(source);
  const existing = cache.get(key);
  if (existing) {
    clearTimeout(existing.timer);
  }
  cache.set(key, { file: result, timer: scheduleEviction(key) });
};
